interface TaskFilterSwitchProps {
    id: string;
    checked: boolean;
    disabled?: boolean;
    className?: string;
    label: string;
    hint: string;
    onChange: (checked: boolean) => void;
}

const TaskFilterSwitch = ({
    id,
    checked,
    disabled = false,
    className = 'form-check form-switch mb-2',
    label,
    hint,
    onChange,
}: TaskFilterSwitchProps) => (
    <div className={className}>
        <input
            className="form-check-input"
            type="checkbox"
            role="switch"
            id={id}
            checked={checked}
            disabled={disabled}
            onChange={(e) => onChange(e.currentTarget.checked)}
        />
        <label className="form-check-label" htmlFor={id}>
            <span className="d-block fs-12">{label}</span>
            <span className="d-block text-muted" style={{ fontSize: '0.65rem', lineHeight: 1.35 }}>
                {hint}
            </span>
        </label>
    </div>
);

export default TaskFilterSwitch;
